import apiClient from "../apiClient";
import { API_ROUTES } from "../../config/baseURL";

const appendQuery = (url, params) => {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const normalized = Array.isArray(value) ? value.join(",") : String(value);
    if (normalized !== "") qs.append(key, normalized);
  });
  const str = qs.toString();
  return str ? `${url}?${str}` : url;
};

export const getLogServicesCatalogos = async () => {
  const res = await apiClient.get(API_ROUTES.logServicesCatalogos);
  return res.data;
};

export const listarLogServices = async (filtros = {}) => {
  const {
    sedes,
    jobCodes,
    codigoError,
    identificacion,
    fechaDesde,
    fechaHasta,
    page = 1,
    perPage = 50,
  } = filtros;

  const params = {};
  if (sedes?.length) params.sedes = sedes;
  if (jobCodes?.length) params.jobCodes = jobCodes;
  if (codigoError) params.codigoError = codigoError;
  if (identificacion) params.identificacion = identificacion;
  if (fechaDesde) params.fechaDesde = fechaDesde;
  if (fechaHasta) params.fechaHasta = fechaHasta;
  params.page = page;
  params.perPage = perPage;

  const res = await apiClient.get(appendQuery(API_ROUTES.logServicesListar, params));
  return res.data;
};

export const inactivarLogServices = async (payload) => {
  const res = await apiClient.post(API_ROUTES.logServicesInactivar, payload);
  return res.data;
};

